module.exports = __webpack_public_path__ + "static/img/tb3.a033bceb.png";